// @react
import React, { ReactElement } from 'react'
import DocumentTitle from 'react-document-title'
// @common
import strings from 'lib/constants/strings'
// @components
import PageTitle from '@bit/atd.web.page-title'
import PageWrapper from 'modules/profile/components/PageWrapper'
import OrderHistoryTabs from 'modules/profile/components/OrderHistoryTabs'

/**
 * 5.0.5  Profile - Payment & Orders
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

const Orders = (): ReactElement => {
  return (
    <PageWrapper>
      <DocumentTitle title="Profile - Security | ATD">
        <>
          <PageTitle subtitle={strings.PROFILE.ORDERS.REVIEW_ORDER_HISTORY}>
            Orders and Downloads
          </PageTitle>
          <OrderHistoryTabs />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Orders
